const hasMissingProperties = (
  obj: unknown,
  requiredProperties: string[]
): boolean => {
  if (typeof obj !== "object" || obj === null) {
    return true;
  }

  if (!Array.isArray(requiredProperties)) {
    throw new Error("requiredProperties must be an array");
  }

  return requiredProperties.some((prop) => {
    const record = obj as Record<string, unknown>;
    return (
      !(prop in record) ||
      record[prop] === undefined ||
      record[prop] === null ||
      record[prop] === ""
    );
  });
};

export default hasMissingProperties;
